import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandMore = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgExpandMore" data-sentry-source-file="expand-more.tsx">
    <g clipPath="url(#expand-more_svg__a)" data-sentry-element="g" data-sentry-source-file="expand-more.tsx">
      <path fill="#263E6A" d="M16.59 8 12 12.58 7.41 8 6 9.41l6 6 6-6z" data-sentry-element="path" data-sentry-source-file="expand-more.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="expand-more.tsx">
      <clipPath id="expand-more_svg__a" data-sentry-element="clipPath" data-sentry-source-file="expand-more.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="expand-more.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgExpandMore;